import { api, act, useFetch } from "@/lib/api";
import { Panel } from "@/components/common";
import { Button } from "@/components/ui/button";

const COLS = [["sent", "Sent"], ["replies", "Replies"], ["bounces", "Bounces"]];

export const SenderScoreboard = () => {
  const { data } = useFetch("/oneplace/senders");
  if (!data || !data.rows.length) return null;
  return (
    <Panel title="Senders today" data-testid="sender-scoreboard"
      action={<Button size="sm" variant="outline" className="h-7 text-xs" data-testid="weekly-report-send-btn"
        onClick={() => act(() => api.post("/reports/weekly/send"), "Last week's report emailed to the admins")}>Email last week's report</Button>}>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[11px] uppercase tracking-wider text-zinc-500 text-left">
            <th className="py-1.5 font-normal">Sender</th>
            {COLS.map(([k, l]) => <th key={k} className="py-1.5 font-normal text-right">{l}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r) => (
            <tr key={r.sender} className="border-t border-border/60" data-testid={`scoreboard-row-${r.sender}`}>
              <td className="py-2 text-white truncate max-w-[220px]">{r.label}</td>
              {COLS.map(([k]) => (
                <td key={k} className={`py-2 text-right tabular-nums ${k === "bounces" && r[k] ? "text-red-400" : ""}`} data-testid={`scoreboard-${k}-${r.sender}`}>{r[k]}</td>
              ))}
            </tr>
          ))}
          <tr className="border-t border-border font-semibold" data-testid="scoreboard-totals">
            <td className="py-2">Total</td>
            {COLS.map(([k]) => <td key={k} className="py-2 text-right tabular-nums">{data.totals[k]}</td>)}
          </tr>
        </tbody>
      </table>
      <p className="text-[11px] text-zinc-500 mt-2">Today since midnight Sydney. Replies are counted against the sender of the prospect's last email; all of them land in the main mailbox. A full weekly report goes to the admins every Monday at 8am.</p>
    </Panel>
  );
};
